var map = {
	"./de/cv-play.png": "r6C7",
	"./en/cv-play.png": "II8E",
	"./es/cv-play.png": "6Lq4",
	"./fr/cv-play.png": "rlhK",
	"./ja/cv-play.png": "KgXy",
	"./ko/cv-play.png": "1WSv",
	"./pt/cv-play.png": "WI7U",
	"./ru/cv-play.png": "2Zn6",
	"./tc/cv-play.png": "h1m2",
	"./th/cv-play.png": "58PG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LFhw";